import { render, staticRenderFns } from "./GroupLocations.vue?vue&type=template&id=572b5bb7&scoped=true&"
import script from "./GroupLocations.vue?vue&type=script&lang=js&"
export * from "./GroupLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b5bb7",
  null
  
)

export default component.exports